module.exports = __webpack_public_path__ + "static/allyio-2a8b650dfa69cff8a85919203b759d18.jpg";